import { render } from "./search-filter-aptitude-test.vue?vue&type=template&id=655ab182"
import script from "./search-filter-aptitude-test.vue?vue&type=script&lang=js"
export * from "./search-filter-aptitude-test.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__